// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnorderedListOutlinedSvg from "@ant-design/icons-svg/es/asn/UnorderedListOutlined";
import AntdIcon from '../components/AntdIcon';

var UnorderedListOutlined = function UnorderedListOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnorderedListOutlinedSvg
  }));
};

UnorderedListOutlined.displayName = 'UnorderedListOutlined';
export default React.forwardRef(UnorderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UnorderedListOutlined.js
// module id = 1983
// module chunks = 0